document.addEventListener("DOMContentLoaded", (event) => {
  
    const faqItems = document.querySelectorAll('.faq_question')

    faqItems.forEach(function(item) {
        item.addEventListener('click', function(){
            
            item.nextElementSibling.classList.toggle('visible')
            item.classList.toggle('visible')
        })
    });
}); 